import { ChangeEvent, useState } from 'react'

interface IUseTableItemsCheckProps {
  items: { id: string }[]
}

const useTableItemsCheck = ({ items }: IUseTableItemsCheckProps) => {
  const [selectedItemsIds, setSelectedItemsIds] = useState<string[]>([])

  const handleAllItemsCheck = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && selectedItemsIds.length === 0) {
      return setSelectedItemsIds(items.map(({ id }) => id))
    }

    setSelectedItemsIds([])
  }

  const handleItemCheck = (id: string) => (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      return setSelectedItemsIds((prev) => [...prev, id])
    }

    setSelectedItemsIds((prev) => prev.filter((item) => item !== id))
  }

  const isItemSelected = (id: string) => selectedItemsIds.indexOf(id) !== -1

  const isAllChecked = !!items.length && selectedItemsIds.length === items.length
  const isIndeterminated = selectedItemsIds.length > 0 && selectedItemsIds.length !== items.length
  const isAllUnchecked = selectedItemsIds.length === 0

  return {
    handleAllItemsCheck,
    handleItemCheck,
    isItemSelected,
    selectedItemsIds,
    setSelectedItemsIds,
    isAllChecked,
    isIndeterminated,
    isAllUnchecked,
  }
}

export { useTableItemsCheck }
